var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Serviços",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('ListaPrecoServicoSelect', {
    model: {
      value: _vm.selectedLista,
      callback: function callback($$v) {
        _vm.selectedLista = $$v;
      },
      expression: "selectedLista"
    }
  }), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Serviço",
      "label-for": "servico"
    }
  }, [_c('VueSelect', {
    ref: "buscarServico",
    class: {
      hasErrors: _vm.servicoError,
      inputFilled: _vm.servicoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.servicosFetched
    },
    on: {
      "input": _vm.setServico,
      "search": _vm.onSearchServico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.discriminacao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.discriminacao) + " ")])];
      }
    }]),
    model: {
      value: _vm.servicoSelected,
      callback: function callback($$v) {
        _vm.servicoSelected = $$v;
      },
      expression: "servicoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o serviço pelo nome ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade"
    },
    model: {
      value: _vm.quantidade,
      callback: function callback($$v) {
        _vm.quantidade = $$v;
      },
      expression: "quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Unitário",
      "label-for": "unitario"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "unitario",
      "name": "unitario"
    },
    model: {
      value: _vm.unitario,
      callback: function callback($$v) {
        _vm.unitario = $$v;
      },
      expression: "unitario"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Valor R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "total",
      "name": "total",
      "disabled": ""
    },
    model: {
      value: _vm.total,
      callback: function callback($$v) {
        _vm.total = $$v;
      },
      expression: "total"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.addServico(_vm.servicoSelected);
      }
    }
  }, [_c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  })], 1)])], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    key: _vm.keyToRender,
    ref: "nome",
    attrs: {
      "item": "serviço",
      "subTitulo": "",
      "data": _vm.store.formServicos,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'discriminacao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "discriminacao"
          },
          slot: "discriminacao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.discriminacao) + " ")])])]) : _vm._e(), props.field == 'quantidade' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.quantidade, 'quantidade')) + " ")])])]) : _vm._e(), props.field == 'unitario' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "unitario"
          },
          slot: "unitario"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.unitario, 'preco')) + " ")])])]) : _vm._e(), props.field == 'total' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "total"
          },
          slot: "total"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.total, 'preco')) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.openModalServico(props.rowData, props.rowData.originalIndex);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteServico(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  }), _vm.modalServicoIsOpen ? _c('ModalServico', {
    attrs: {
      "close": _vm.closeModalServico,
      "changeServico": _vm.saveEditProduto,
      "servico": _vm.servicoToEdit,
      "open": _vm.modalServicoIsOpen
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };